export default __webpack_public_path__ + "static/ArminGrotesk-Normal-78793058573fc29166cf02742fbe6bda.woff";